<template>
  <v-expansion-panels flat class="flat-expanssion-panel">
    <v-expansion-panel>
      <v-expansion-panel-header ripple color="grey lighten-4" class="accent--text d-flex align-center justify-content-between">
        <v-tooltip color="white" v-if="contentJson?.lang?.[language]?.text || contentJson?.text" right content-class="tooltip-box-content" max-width="360" :open-delay="300" :close-delay="200" transition="slide-x-transition">
          <template v-slot:activator="{on, attrs}">
            <div v-bind="attrs" v-on="on" style="margin-right: -40px">
              {{ $t("overlay-zoning-plan") }}
            </div>
          </template>
          <div v-html="contentJson?.lang?.[language]?.text || contentJson?.text"></div>
        </v-tooltip>
        <div v-else>
          {{ $t("overlay-zoning-plan") }}
        </div>
      </v-expansion-panel-header>
      <v-expansion-panel-content>
        <v-simple-table dense>
          <template v-slot:default>
            <tbody>
              <TooltipTR section="section500" field="OVL_COL" :label="$t('base-building-lines')">
                <div>{{ $t("base-building-lines") }}</div>
                <div>{{ plotItem.OVL_COL }}</div>
              </TooltipTR>
              <TooltipTR section="section500" field="OVL_CSL" :label="$t('building-lines-cantonal-roads')">
                <div>{{ $t("building-lines-cantonal-roads") }}</div>
                <div>{{ plotItem.OVL_CSL }}</div>
              </TooltipTR>
              <TooltipTR section="section500" field="OVL_NSL" :label="$t('building-lines-national-roads')">
                <div>{{ $t("building-lines-national-roads") }}</div>
                <div>{{ plotItem.OVL_NSL }}</div>
              </TooltipTR>
              <TooltipTR section="section500" field="OVL_FOL" :label="$t('building-lines-forest-distance')">
                <div>{{ $t("building-lines-forest-distance") }}</div>
                <div>{{ plotItem.OVL_FOL }}</div>
              </TooltipTR>
              <TooltipTR section="section500" field="OVL_NOI" :label="$t('noise-sensitivity-level')">
                <div>{{ $t("noise-sensitivity-level") }}</div>
                <div>{{ plotItem.OVL_NOI }}</div>
              </TooltipTR>
              <TooltipTR section="section500" field="OVL_WAL" :label="$t('water-space-line')">
                <div>{{ $t("water-space-line") }}</div>
                <div>{{ plotItem.OVL_WAL }}</div>
              </TooltipTR>
              <TooltipTR section="section500" field="OVL_WAA" :label="$t('water-space')">
                <div>{{ $t("water-space") }}</div>
                <div>{{ plotItem.OVL_WAA }}</div>
              </TooltipTR>
            </tbody>
          </template>
        </v-simple-table>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels>
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-property-decorator"
import TooltipTR from "./TooltipText.vue"

@Component({
  components: {TooltipTR},
})
export default class ViewPlotDetails300 extends Vue {
  @Prop()
  plotItem

  contentJson: any = {}
  language

  created() {
    this.language = localStorage.getItem("user-language") || "en"
    this.loadTooltip()
  }

  async loadTooltip() {
    this.contentJson = (await this.$store.dispatch("tooltip/getTooltipContent", "section500")) || {}
  }

}
</script>

